module.exports = __webpack_public_path__ + "img/9dd7e9f.jpg";